<div class="sw-cms-block-moorl-column-layout-2-3">
    <slot name="slot-a"></slot>
    <slot name="slot-b"></slot>
</div>